import { useEffect } from 'react'

/**
 * Close a body-portaled Ant Design Dropdown when the story-map board
 * (or any ancestor) scrolls, so the menu does not drift away from its card.
 */
const useCloseDropdownOnScroll = (open, onClose) => {
    useEffect(() => {
        if (!open) return undefined

        const handleScroll = (event) => {
            const target = event.target
            if (
                target instanceof Element &&
                (target.closest('.ant-dropdown') ||
                    target.closest('.ant-dropdown-menu'))
            ) {
                return
            }
            onClose?.()
        }

        window.addEventListener('scroll', handleScroll, true)
        return () => window.removeEventListener('scroll', handleScroll, true)
    }, [open, onClose])
}

export default useCloseDropdownOnScroll
